import { render } from "./AnswerEvaluation.vue?vue&type=template&id=49884b74"
import script from "./AnswerEvaluation.vue?vue&type=script&lang=js"
export * from "./AnswerEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__